import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import NotificationChip from './NotificationChip'

import { commentNotifications } from '../selectors/notifications'

let select = (state, props) => ({
	notifications: commentNotifications(state, props)
})

export class CommentNotifications extends Component {
	render(){
		let { props } = this
		return(
			<div className="notification-chip" style={{display: (props.notifications.length)?"inline-block": "none"}}>
				{
					(props.notifications.length)?
						props.notifications.map((x) => <NotificationChip id={x._id} />)
					:
						null
				}
			</div>
		)
	}
}

export default connect(select)(CommentNotifications)



// WEBPACK FOOTER //
// ./src/components/CommentNotifications.js